import { render, staticRenderFns } from "./Func10Novo.vue?vue&type=template&id=28061eb3&scoped=true"
import script from "./Func10Novo.vue?vue&type=script&lang=js"
export * from "./Func10Novo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28061eb3",
  null
  
)

export default component.exports